export const logStart = (event, detail) => {
  if (detail !== undefined) console.log(`[start] ${event}`, detail);
  else console.log(`[start] ${event}`);
};
